module.exports = __webpack_public_path__ + "img/navright-ad.8f75a026.png";